
import {PlayerIFrame as VimeoPlayerIFrame} from '@rcm/vimeo-player';
export default class PlayerIFrame extends VimeoPlayerIFrame {}
